module.exports = __webpack_public_path__ + "static/img/logo-amadeus.b2327f8e.svg";